<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3">The Mill</span> </p>
<p class="calibre2"> <span class="calibre4">Ron Stelle</span> </p>
<p class="calibre2"> <span class="calibre5">All rights reserved</span> </p>
<p class="calibre2"> <span class="calibre4"> </span> </p>
<p class="calibre2"> <span class="calibre4"> </span> </p>
<p class="calibre2"> <span class="calibre4">Pen It! Publications </span> </p>
<p class="calibre2"> <span class="calibre4">© 2017</span> </p>
<p class="calibre2"> <span class="calibre4"> </span> </p>
<p class="calibre2"> <span class="calibre6">ISBN #:    978-1544118840</span> </p>
<p class="calibre2"> <span class="calibre6">ISBN #:     1544118848</span> </p>
<p class="calibre2"> <span class="calibre6"> </span> </p>
<p class="calibre2"> <span class="calibre6">Edited by:  Wanda Williams, Pen It! Publications, LLC</span> </p>
<p class="calibre2"> <span class="calibre6">Cover Art by:  Debra Hetzel Hanson</span> </p>
<p class="calibre2"> <span class="calibre6">First Edition © 2017</span> </p>
<p class="calibre2"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre8" id="calibre_pb_0"></span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_000.vue?7e975986